<div class="sidebar">
  <nav class="nav">
    <ul>
      <li routerLinkActive="active"><a [routerLink]="'/courts'" (click)="navigate()">Бронювання корту</a></li>
      <li routerLinkActive="active"><a [routerLink]="'/tournaments'" (click)="navigate()">Турніри</a></li>
<!--      <li routerLinkActive="active"><a [routerLink]="'/courses'" (click)="navigate()" *ngIf="authService.user?.role === 'coach' || authService.user?.isAdmin">Тренування</a></li>-->
      <li routerLinkActive="active"><a [routerLink]="'/admin'" (click)="navigate()" *ngIf="authService.user?.isAdmin">Адміністрування</a></li>
      <li routerLinkActive="active"><a [routerLink]="'/championships'" (click)="navigate()">Чемпіонати</a></li>
      <li routerLinkActive="active"><a [routerLink]="'/about'" (click)="navigate()">Про нас</a></li>
    </ul>
  </nav>
</div>
